import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { getPlanFrontendProperties } from "./membershipsPageConfig";
import { useSelector } from "react-redux";
import PlanHeader from "./membershipPlanCard/PlanHeader";
import PlanFeatures from "./membershipPlanCard/PlanFeatures";
import PlanActionButton from "./membershipPlanCard/PlanActionButton";

const MembershipPlanCard = ({
  plan,
  isMember,
  onSelectPlan,
  onLearnMore,
  variants,
  trialEligible,
  userPlan,
  selectedPlanId,
}) => {
  const { isPlanProcessing } = useSelector((state) => state.membership);
  const frontendProps = getPlanFrontendProperties(plan.id);
  const isCurrentPlan = userPlan === plan.id;
  // Show trial highlight ring on paid plans when user is trial-eligible
  const showTrialHighlight = trialEligible && plan.id !== "free";

  return (
    <motion.div variants={variants} className="flex relative">
      <Card
        className={cn(
          "flex flex-col w-full border transition-shadow hover:shadow-md",
          plan.popular && isMember && !isCurrentPlan
            ? "border-2 border-primary shadow-xl relative overflow-hidden bg-primary/5 transform lg:scale-105 z-10"
            : "",
          selectedPlanId && selectedPlanId !== plan.id ? "opacity-70" : "",
          isCurrentPlan ? "border-2 border-green-500 bg-green-500/5" : "",
          showTrialHighlight && !isCurrentPlan
            ? "border-2 border-primary/60 bg-primary/5"
            : "",
        )}
      >
        {plan.popular && isMember && !isCurrentPlan && (
          <div className="absolute top-0 -right-6 bg-primary text-primary-foreground text-xs font-bold px-10 py-1.5 transform rotate-45 translate-x-6 translate-y-4 shadow-md z-20">
            Most Popular
          </div>
        )}

        <CardHeader className="items-center text-center pb-4 pt-8">
          <PlanHeader
            plan={plan}
            frontendProps={frontendProps}
            isMember={isMember}
            trialEligible={trialEligible}
            userPlan={userPlan}
          />
        </CardHeader>

        <CardContent className="flex-grow space-y-3 px-6 pb-6">
          <PlanFeatures features={plan.features} />
        </CardContent>

        <div className="p-6 pt-0 mt-auto">
          <PlanActionButton
            plan={plan}
            userPlan={userPlan}
            isMember={isMember}
            isPlanProcessing={isPlanProcessing}
            selectedPlanId={selectedPlanId}
            onSelectPlan={onSelectPlan}
            onLearnMore={onLearnMore}
            frontendProps={frontendProps}
            trialEligible={trialEligible}
          />
        </div>
      </Card>
    </motion.div>
  );
};

export default MembershipPlanCard;
